import React from 'react';
import '../contact me/Contact.css'

export default function Contact() {
  return (
      <><section className='content my-5' id='contact'>
          <h1 className='d-flex justify-content-center'>Contact</h1>
          <div className="container justify-content-center ">
              <h3 className='d-flex justify-content-center'>Have Any Project?</h3>
              {/* <p className='mx-5 contact-text'>Write an email to me by clicking button below</p> */}
              <div className='my-3 probtn'>
                    <a href="mailto:avanishpandey022@gmail.com?subject=Project"><button className='btn btn-5 bttn'>Write an email</button></a>
              </div>
          </div>
          
          
          </section>
      </>
  );
}
